export const limitedReleaseByPhysicalConstants = {
  LIMITED_RELEASE_BY_PHYSICAL_LOADING: "LIMITED_RELEASE_BY_PHYSICAL_LOADING",
  LIMITED_RELEASE_BY_PHYSICAL_SUCCESS: "LIMITED_RELEASE_BY_PHYSICAL_SUCCESS",
  LIMITED_RELEASE_BY_PHYSICAL_FAILURE: "LIMITED_RELEASE_BY_PHYSICAL_FAILURE",
};

export const createLimitedReleaseByPhysicalConstants = {
  CREATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
    "CREATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING",
  CREATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
    "CREATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS",
  CREATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
    "CREATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE",
};

export const editLimitedReleaseByPhysicalConstants = {
  EDIT_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
    "EDIT_LIMITED_RELEASE_BY_PHYSICAL_LOADING",
  EDIT_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
    "EDIT_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS",
  EDIT_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
    "EDIT_LIMITED_RELEASE_BY_PHYSICAL_FAILURE",
};

export const deleteLimitedReleaseByPhysicalConstants = {
  DELETE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
    "DELETE_LIMITED_RELEASE_BY_PHYSICAL_LOADING",
  DELETE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
    "DELETE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS",
  DELETE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
    "DELETE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE",
};

export const activateLimitedReleaseByPhysicalConstants = {
  ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
    "ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING",
  ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
    "ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS",
  ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
    "ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE",
};

export const deactivateLimitedReleaseByPhysicalConstants = {
  DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
    "DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING",
  DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
    "DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS",
  DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
    "DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE",
};
